export default class FeatureSettings {
  static SERVICE_NAME = 'featureSettings';

  constructor({ app }) {
    this.axios = {
      withToken() {
        return app.$axios.create({
          baseURL : process.env.INTEGRATE_MODULE_API,
          headers : {
            Accept            : 'application/json',
            'Content-Type'    : 'application/json',
            'x-api-key'       : process.env.INTEGRATE_MODULE_API_KEY,
            'Accept-Language' : app.i18n.locale,
            Authorization     : app.$token.get()
          }
        });
      }
    };
  }

  getAllFeatureSettings(params) {
    return this.axios.withToken().get(`/feature-settings`, { params });
  }
}
